import Call from "../utils/Call";

class EmailLambda extends Call {
    constructor() {
        super('https://laqs2v3airg5fcdsdxlx3tweqm0srhnd.lambda-url.us-east-1.on.aws');
    }

    header() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer oaidjfoaidJASDI0989h43#kajdf0!dlfasdf5Df`,
        };
    }

    async sendEmail(data) {
        try {
            return await this.call("post", ``, { data });
        } catch (err) {
            console.error("Erro ao enviar e-mail:", err);
            return false;
        }
    }
}

export default new EmailLambda();
